import React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';
import { Tab, TabProps, units } from '@ha/dsl';

export const styles = (t: Theme) =>
  createStyles({
    root: {
      zIndex: 1,
      maxWidth: 'initial',
      textTransform: 'none',
      minWidth: units.rem(9),
      [t.breakpoints.up('md')]: {
        minWidth: units.rem(15),
      },
    },
    selected: {
      color: t.palette.primary.main,
    },
  });

interface StyledTabProps {
  selectedClassName?: string;
}

type Props = StyledTabProps & TabProps & WithStyles<typeof styles>;

export const StyledTab: React.FC<Props> = ({
  selectedClassName,
  classes,
  ...otherProps
}) => (
  <Tab
    disableRipple
    classes={{
      ...classes,
      ...(selectedClassName ? { selected: selectedClassName } : {}),
    }}
    {...otherProps}
  />
);

export default withStyles(styles)(StyledTab);
